/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import Page from '../Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import $ from 'jquery'
import {Link} from 'react-router-dom'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import SearchableCombo from '../BaseComponent/searchableCombo'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Loader from '../loaders/loader'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'

class Products extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      Products: [],
      printInfo: [],
      comboProvides: [],
      lengthProducts: 0,
      pageNumber: 1,
      providerId: '',
      buttonClicked: false
    }
  }

  componentDidMount() {
    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {

    //     if (response.data.error == null) {

    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] =result[i].providerId +' - '+ result[i].title;
    //         }

    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.removeItem('params')

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  onResultFetched(data) {
    this.setState({
      Products: data
    })
  }

  changeDropDown(data) {
    this.setState({
      Products: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  getValueProvider = (providerId) => {
    this.setState({
      providerId
    })
  }

  filter() {
    let {loading} = this.state
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    var productName = $('#productName')
      .val()
      .trim()
    var providerId = this.state.providerId
    var articleId = $('#articleId')
      .val()
      .trim()
    var productCode = $('#productCode')
      .val()
      .trim()
    if (productName === '' && providerId === '' && articleId === '' && productCode === '') {
      message.error('یک فیلتر وارد شود')
    } else {
      this.setState({
        loading: true
      })
      sessionStorage.setItem(
        'params',
        `productCode=${productCode}&productName=${productName}&providerId=${providerId}&articleId=${articleId}`
      )

      http
        .get(
          `${
            REPORT_RETAIL.REPORT_RETAIL_PRODUCT
          }?export=false&pageSize=10&pageNumber=1&productCode=${productCode}&productName=${productName}&providerId=${providerId}&articleId=${articleId}`,
          {}
        )
        .then((response) => {
          // alert(JSON.stringify(response))

          if (response.data.error == null) {
            $('.showBaseTable').fadeIn()

            this.setState({
              Products: response.data.object.result,
              lengthProducts: response.data.object.countAll,
              buttonClicked: true,
              loading: false
            })
          } else {
            $('.showBaseTable').fadeOut()
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
            this.setState({
              loading: false
            })
          }
        })
    }
  }

  exportExcel = () => {
    http
      .get(
        `${REPORT_RETAIL.REPORT_RETAIL_PRODUCT}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })

    http
      .get(
        `${REPORT_RETAIL.REPORT_RETAIL_PRODUCT}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response))

        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result,
            loading: false
          })
        }
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let {loading} = this.state
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let urlParams = sessionStorage.getItem('params')
    let excelColumns = [
      {title: 'نام محصول', value: 'productName'},
      {title: 'کد محصول', value: 'productCode'},
      {title: 'نام تامین کننده', value: 'providerName'}
    ]

    let name = cookie.load('name')
    let columns = ['ردیف', 'نام محصول', 'بارکد محصول', 'کد محصول', 'نام تامین کننده']

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست محصولات"
              headerColSpan={5}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((products, index) => (
                <tr key={'i' + index}>
                  <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                  <td>{products.productName}</td>
                  <td>{products.productCode}</td>
                  <td>{products.articleId}</td>
                  <td>{products.providerName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش محصولات.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'productName'}
                field={'productName'}
                title={'نام'}
                width="250px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'productCode'}
                field={'productCode'}
                title={'بارکد'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'articleId'}
                field={'articleId'}
                title={'کد محصول'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'providerName'}
                field={'providerName'}
                title={'تامین کننده'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>لیست محصولات</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={REPORT_RETAIL.REPORT_RETAIL_PRODUCT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl="test"
                  execelUrl={REPORT_RETAIL.REPORT_RETAIL_PRODUCT + '?export=true'}
                  excelColumns={excelColumns}
                  printComponent={this.printTable}
                  titleAdd=""
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>نام محصول</label>
                  <input className="form-control" id="productName" type="text" />
                </div>

                <div className="formComponent">
                  <label>کد محصول</label>
                  <input className="form-control" id="articleId" type="text" />
                </div>
                <div className="formComponent">
                  <label>بارکد محصول</label>
                  <input className="form-control" id="productCode" type="text" />
                </div>
                <div className="formComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <SearchableCombo
                                        options={this.state.providers}
                                        getValueCombo={this.getValueProvider}
                                        lableText='تامین کنندگان'
                                        placeholder='------'
                                        isClearable={true}
                                        isMulti={false}
                                    /> */}
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div
              className="showBaseTable"
              style={this.state.Products.length === 0 ? {display: 'none'} : {display: 'block'}}
            >
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام محصول</td>
                    <td>بارکد محصول</td>
                    <td>کد محصول</td>
                    <td>نام تامین کننده</td>
                  </tr>
                  {this.state.Products.map((products, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: products.articleId})}>
                          {products.productName}
                        </a>
                      </td>
                      <td>{products.productCode}</td>
                      <td>{products.articleId}</td>
                      <td>{products.providerName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.lengthProducts}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={REPORT_RETAIL.REPORT_RETAIL_PRODUCT}
                  urlParams={urlParams}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Products
